import React from "react";
import avatar from "../assets/avatar.png";
import { NavLink } from "react-router-dom";

function Navbar() {
 return (
  <div className="NavBar">
   <nav className="nav">
    <div className="profile">
     <img src={avatar} alt="" />
    </div>

    <ul className="nav-items">
     <li className="nav-item">
      <NavLink to="/" exact activeClassName="active">
       Accueil
      </NavLink>
     </li>
     <li className="nav-item">
      <NavLink to="/about" exact activeClassName="active">
       À propos
      </NavLink>
     </li>
     <li className="nav-item">
      <NavLink to="/portfolios" exact activeClassName="active">
       Projets
      </NavLink>
     </li>
     <li className="nav-item">
      <NavLink to="/blogs" exact activeClassName="active">
       Blog
      </NavLink>
     </li>
    </ul>
    <footer className="footer">
     <p>@2021 Tous Droits réservés</p>
    </footer>
   </nav>
  </div>
 );
}

export default Navbar;
